import { apiInstance } from "shared/api";
import {
  ApiTasksResponse,
  TaskData,
  GetTasksParams,
  SignTasksResponse,
  CheckSignTaskBody,
  CheckSignTasksResponse,
} from "./types";

export const getTasks = (params?: GetTasksParams): Promise<ApiTasksResponse> =>
  apiInstance.get("/v1/tasks", { params }).then((response) => response.data);

export const getTaskById = (id: string): Promise<TaskData> =>
  apiInstance.get(`/v1/tasks/${id}`).then((response) => response.data);

export const acceptTaskById = (id: string): Promise<TaskData> =>
  apiInstance.patch(`/v1/tasks/${id}/accept`).then((response) => response.data);

export const declineTaskById = (id: string): Promise<TaskData> =>
  apiInstance
    .patch(`/v1/tasks/${id}/decline`)
    .then((response) => response.data);

export const respondTaskById = (
  id: string,
): Promise<{
  success: true;
}> =>
  apiInstance
    .patch(`/v1/tasks/${id}/respond`)
    .then((response) => response.data);

export const signTaskById = (
  id: string,
  params?: { provider: string },
): Promise<SignTasksResponse> =>
  apiInstance
    .post(`/v1/tasks/${id}/sign`, params)
    .then((response) => response.data);

export const checkSignTaskById = (
  id: string,
  params: CheckSignTaskBody,
): Promise<CheckSignTasksResponse> =>
  apiInstance
    .post(`/v1/tasks/${id}/sign-check`, params)
    .then((response) => response.data);

export const getTaskPdfById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/tasks/${id}/download`, {
      responseType: "blob",
    })
    .then((response) => response.data);

export const downloadTaskById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/tasks/${id}/download-archive`, {
      responseType: "blob",
    })
    .then((response) => response.data);
